var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayerCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C3 3.84315 4.34315 2.5 6 2.5H11.6667C13.3235 2.5 14.6667 3.84315 14.6667 5.5V11.1667C14.6667 12.8235 13.3235 14.1667 11.6667 14.1667H6C4.34315 14.1667 3 12.8235 3 11.1667V5.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 9.16666L7.58337 10.4167L11.3334 6.66666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.83334V14.5C18 16.1569 16.6569 17.5 15 17.5H6.33337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerCheck);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zIDUuNUMzIDMuODQzMTUgNC4zNDMxNSAyLjUgNiAyLjVIMTEuNjY2N0MxMy4zMjM1IDIuNSAxNC42NjY3IDMuODQzMTUgMTQuNjY2NyA1LjVWMTEuMTY2N0MxNC42NjY3IDEyLjgyMzUgMTMuMzIzNSAxNC4xNjY3IDExLjY2NjcgMTQuMTY2N0g2QzQuMzQzMTUgMTQuMTY2NyAzIDEyLjgyMzUgMyAxMS4xNjY3VjUuNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuMzMzMzcgOS4xNjY2Nkw3LjU4MzM3IDEwLjQxNjdMMTEuMzMzNCA2LjY2NjY2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOCA1LjgzMzM0VjE0LjVDMTggMTYuMTU2OSAxNi42NTY5IDE3LjUgMTUgMTcuNUg2LjMzMzM3IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };